var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleFirstIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0823 15.4268L16.2773 14.2317L12.3955 10.3414L16.2773 6.45109L15.0823 5.25603L9.99692 10.3414L15.0823 15.4268Z",
    fill: "#191E31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49635 15.4268L10.6914 14.2317L6.80958 10.3414L10.6914 6.45109L9.49634 5.25603L4.41098 10.3414L9.49635 15.4268Z",
    fill: "#191E31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleFirstIcon);
export default __webpack_public_path__ + "static/media/doubleFirstIcon.224b578b4fea1df33fc5bbf9548f1167.svg";
export { ForwardRef as ReactComponent };